export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="privacy-page">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#9CA47E] mb-3">⌗ Legal</div>
      <h1 className="font-heading text-5xl tracking-tight">Privacy Policy</h1>
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#595959] mt-4">Last updated · February 2026</p>

      <div className="prose prose-neutral mt-10 font-body text-[15px] text-[#333333] leading-relaxed space-y-6">
        <section>
          <h2 className="font-heading text-2xl">1. Who we are</h2>
          <p>
            VoraStyle (“we”, “us”) operates vorastyle.com — a creative curation platform for fashion and interior design
            mood-boards. This policy explains what data we collect, how we use it, and the rights you have over it.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">2. What we collect</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Account info</strong> — email, username, hashed password.</li>
            <li><strong>Content you create</strong> — sets, clipped products, comments, likes, follows.</li>
            <li><strong>Usage</strong> — basic analytics (page views, device type) so we can improve the product.</li>
            <li><strong>Optional</strong> — profile bio &amp; avatar if you choose to upload one.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl">3. How we use it</h2>
          <p>To run the service, authenticate you, deliver the canvas editor, show you relevant sets, and respond to support requests. We do <em>not</em> sell your data.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">4. Cookies</h2>
          <p>We use a single first-party authentication cookie to keep you signed in. No third-party advertising trackers.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">5. Your rights</h2>
          <p>Email <a href="mailto:Support@VoraStyle.com" className="underline underline-offset-4 decoration-[#9CA47E]">Support@VoraStyle.com</a> any time to access, export, or delete your data. Account deletion is permanent.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl">6. Contact</h2>
          <p>VoraStyle · Support@VoraStyle.com</p>
        </section>
      </div>
    </div>
  );
}
